import cookieUtil from 'tradera-utils/cookie';
import { SHIPPING_COUNTRY } from 'tradera-constants/cookies';
import {
    isSwedenCountryCodeOrUndefined,
    isSwedenCountryNameOrUndefined
} from 'tradera-utils/countrycode';

const getInitialCategoryId = initData => {
    if (initData.categoryPath && initData.categoryPath.length > 0) {
        initData.categoryPath.forEach(item => {
            if (item.selected) {
                return item.id;
            }
        });
    }
    return 0;
};

export default initData => {
    const { isLoggedIn, memberCountry } = initData;
    return {
        activeBrands: [],
        activeFilters: [],
        attributeFilters: [],
        categoryPath: initData.categoryPath || [],
        currentCategoryId: getInitialCategoryId(initData),
        displayAllowedBuyerRegionFilter:
            (cookieUtil.hasCookie(SHIPPING_COUNTRY) &&
                !isSwedenCountryCodeOrUndefined(
                    cookieUtil.readCookie(SHIPPING_COUNTRY)
                )) ||
            (isLoggedIn && !isSwedenCountryNameOrUndefined(memberCountry)),
        endpoint: null,
        error: null,
        fallbackItemsById: [],
        filterCategories: {},
        filterPrice: {},
        filters: {},
        hasResult: false,
        headerText: null,
        internalSearch: {},
        introText: null,
        isFetchingGeolocation: false,
        isShopOwnedByCurrentMember: false,
        itemsById: [],
        itemsOnDisplayById: [],
        mainText: null,
        pagination: null,
        queryParams: {},
        totalItems: 0,
        discoverTranslationResult: {},
        reduxContainer: {}
    };
};
